import { api } from "@/lib/api";

/**
 * One row from `mcp_tokens` minus secret material. Mirrors the
 * `McpToken` Rust struct in `crates/mcp/src/model.rs`.
 *
 * `revoked_at` is non-null for soft-deleted tokens; the UI greys
 * them out instead of hiding them so the user can see prior
 * activity (a revoked-after-leak token is forensically useful).
 */
export interface McpToken {
  id: number;
  user_id: number;
  name: string;
  last_used_at: string | null;
  revoked_at: string | null;
  created_at: string;
}

/**
 * Response from `POST /api/v1/mcp/tokens`. The cleartext bearer
 * is included exactly once — on creation. It is never returned
 * again from any other endpoint; the user MUST copy it now.
 */
export interface CreateMcpTokenResponse {
  token: McpToken;
  cleartext: string;
}

export const mcpApi = {
  list: (): Promise<McpToken[]> => api("/api/v1/mcp/tokens"),

  create: (name: string): Promise<CreateMcpTokenResponse> =>
    api("/api/v1/mcp/tokens", {
      method: "POST",
      body: JSON.stringify({ name }),
    }),

  revoke: (id: number): Promise<void> =>
    api(`/api/v1/mcp/tokens/${id}`, { method: "DELETE" }),
};
